import { getGradeTitle } from '../../../../constants/shared/GradesConstants';
import { getUrlString } from '../../../../utils/shared/urlUtils';

export const getGradeYearString = (gradeYear = {}) => {
    const { grade = '', year = '' } = gradeYear;
    return `${grade}_${year}`;
};

export const getYearsContraction = year =>
    `'${(year - 1).toString().slice(-2)} - '${year.toString().slice(-2)}`;

export const getGradeNavTabs = (gradeYears, params) => {
    return gradeYears.map(gradeYear => {
        const gradeYearPair = getGradeYearString(gradeYear);
        return {
            id: gradeYearPair,
            title: getGradeTitle(gradeYear.grade),
            spanText: getYearsContraction(gradeYear.year),
            path: getUrlString('', {
                ...params,
                gradeYear: gradeYearPair,
            }),
        };
    });
};
